import { Component, OnInit } from '@angular/core';
import { RouteService } from 'app/services/route.service';
import { PopupService } from 'app/services/shared/popup.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { FilterService } from 'app/shared/filter/filter.service';

@Component({
  selector: 'app-list-route',
  templateUrl: './list-route.component.html',
  styleUrls: ['./list-route.component.scss'],
  providers: [RouteService]
})
export class ListRouteComponent implements OnInit {
  routes: any = [];
  message = "Loading Standard Routes...";
  public isLoading = false;
  showNum: number = 10;
  lblHeading = 'Standard Routes';
  isEmpty: boolean = false;
  deleteConfirm = '';

  constructor(private routeService: RouteService,private toastService:ToastNotificationService,
    private showModal: PopupService, private toastr: ToastrService, private confirmDialogService: ConfirmDialogService,
    private routr: Router, public utility: UtilityServiceService, private filter:FilterService) { }

  ngOnInit() {
    this.utility.setDirection(true);
    this.getRoutes();
  }
  getRoutes() {
    this.isLoading = true;
    this.routeService.getAllRoute().subscribe(data => {
      this.isLoading = false;
      this.routes = data;
      for (let index = 0; index < this.routes.length; index++) {
        let element = this.routes[index];
        if (element.route_type_ind == 1)
          element.route_type_ind = "Standard descriptive";
        if (element.route_type_ind == 3)
          element.route_type_ind = "Standard with legs/places";
        if (element.route_type_ind == 5)
          element.route_type_ind = "Standard desc & legs";
        if (element.route_type_ind == 11)
          element.route_type_ind = "Carrier-defined descriptive";
        if (element.route_type_ind == 13)
          element.route_type_ind = "Carrier-defined with legs/places";
        if (element.route_type_ind == 15)
          element.route_type_ind = "Carrier-defined desc & legs";
        if(element.distance == undefined)
          element.distance = 0;
        if(element.duration == undefined){
          element.duration = 0;
          }
          else{
            element.duration = this.toHoursAndMinutes(element.duration );
          }
        if(element.freight_passenger_ind == 1)
          element.freight_passenger_ind = "Freight";
        if(element.freight_passenger_ind == 2)
          element.freight_passenger_ind = "Passenger";
        if(element.freight_passenger_ind == 3)
          element.freight_passenger_ind = "Both";
        if(element.freight_passenger_ind == undefined)
          element.freight_passenger_ind = "None";
        if(element.num_border_crossings == undefined)
          element.num_border_crossings = 0;
        this.routes[index] = element;
      }
      this.isEmpty = (this.routes.length == 0) ? true : false;
      //this.utility.onSort(5);
    });
  }

  toHoursAndMinutes(totalMinutes) {
    const minutes = totalMinutes % 60;
    const hours = Math.floor(totalMinutes / 60);
  
    return `${hours}h${minutes > 0 ? ` ${minutes}m` : ''}`;
  }

  onConfirm(id) {

    this.deleteConfirm = `Are you sure you want to delete this Route?`;
   
    this.confirmDialogService.confirmThis(this.deleteConfirm, () => {  
      this.isLoading = true;
      this.delete(id);
    }, () =>  {  
      return;
    }) 

  }

  delete(id) {
    this.routeService.deleteRoutes(id).subscribe((x: any) => {
      //console.log(x);
      this.getRoutes();
      this.isLoading = false;
      this.toastService.success('Delete Route', 'Route deleted successfully');
      this.routr.navigateByUrl('/route/management/list');
    },
      error => {
        //console.log(error.error.Message)
        this.isLoading = false;
        this.toastService.error('Failed to delete route. This route is linked to applications or transport associations', 'Delete Route')
        // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        return;
      });
  }
  onSearch() {

    this.filter.getData().subscribe(data => {

        //status filter
        let statutes: any = [];
        data.consultantStatusMultiSelect?.forEach(x => {
            statutes.push(x.desc);
        });

        //roles filter
        let roles: any = [];
        data.consultantRoleMultiSelect?.forEach(x => {
            roles.push(x.id);
        });

        let filter_object = {
            "RouteName": data.routeName ? data.routeName : "",
            "ProvinceId": data.provinceName ? data.provinceName : 0,
            "DestinationCountry": data.destinationCountry ? data.destinationCountry : 0,
            "showTranxAssociationOnly": data.routesDedicatedtoMyTransAssoc ? data.routesDedicatedtoMyTransAssoc : null,
            "passenger_freight_id": data.passenger_freight_id ? data.passenger_freight_id : null
        }

        this.getRoutesByFilters(filter_object);
        // this.getConsultantsList(this.carrierID, data.consultantUserName, data.consultantStatusMultiSelect != null ? data.consultantStatusMultiSelect[0]?.desc : "", data.consultantRoleMultiSelect  != null ? data.consultantRoleMultiSelect[0]?.id : 0);
    });
}

getRoutesByFilters(params){

    this.routeService.getRoutesFilter(params).subscribe(data => {
        this.isLoading = false;
        this.routes = data;
        console.log('Routes List', this.routes);

        for (let index = 0; index < this.routes.length; index++) {

            let element = this.routes[index];
            let stops = element.route_leg?.filter(x => x.is_from_stop_spot).length;
            element.numberOfStops = stops;
            if (element.route_type_ind == 1) {
                element.route_type_ind = 'Standard descriptive';
            }
            if (element.route_type_ind == 3) {
                element.route_type_ind = 'Standard with legs/places';
            }
            if (element.route_type_ind == 5) {
                element.route_type_ind = 'Standard desc & legs';
            }
            if (element.route_type_ind == 11) {
                element.route_type_ind = 'Carrier-defined descriptive';
            }
            if (element.route_type_ind == 13) {
                element.route_type_ind = 'Carrier-defined with legs/places';
            }
            if (element.route_type_ind == 15) {
                element.route_type_ind = 'Carrier-defined desc & legs';
            }
            if(element.duration == undefined){
              element.duration = 0;
              }
              else{
                element.duration = this.toHoursAndMinutes(element.duration );
              }
            if(element.freight_passenger_ind == 1)
                element.freight_passenger_ind = "Freight";
            if(element.freight_passenger_ind == 2)
                element.freight_passenger_ind = "Passenger";
            if(element.freight_passenger_ind == 3)
                element.freight_passenger_ind = "Both";
            if(element.freight_passenger_ind == undefined)
                element.freight_passenger_ind = "None";
            this.routes[index] = element;
        }
        this.isEmpty = (this.routes.length == 0) ? true : false;
        //// this.utility.onSort(5);
    });
};

}
